import React from 'react';
import moment from 'moment';
import { Weekdays } from '../Common';
import { FormGroup, Input } from 'reactstrap';
import {
    FormLabel,
    ValidationErrorMessage,
} from '../common/forms/FormElements';
import Select from 'react-select';
import { MaxResourceCount } from './LongTermSchedule';

export default class ReleasedLongTermScheduleDetails extends React.Component {
    getDayName = () => {
        const { eventDate } = this.props;

        if (!eventDate) {
            return null;
        }

        return Weekdays[moment(eventDate).day()].name.toLowerCase();
    };

    getLowboyResourcesForDay = () => {
        const { job, eventDate } = this.props;

        if (!job || !job.lowboyResources) {
            return [];
        }

        return job.lowboyResources.filter((lr) =>
            moment(lr.date).isSame(eventDate, 'day')
        );
    };

    render() {
        const {
            longTermSchedule,
            cancelWorkflowEnabled,
            isReleased,
            isCancelled,
            applicationGroups,
            equipmentGroups,
            onChange,
            onEquipmentGroupChange,
            arcGisLocations,
            onArcGisLocationChange,
        } = this.props;

        if (
            cancelWorkflowEnabled ||
            (longTermSchedule.isPublished && !isReleased)
        ) {
            return null;
        }

        const applicationGroup = applicationGroups.find(
            (ag) =>
                longTermSchedule.scheduleApplicationGroupCount
                    .applicationGroupId == ag.id
        );

        const anyLocationsDefined = Boolean(
            arcGisLocations && arcGisLocations.length > 0
        );

        return (
            <div className="d-flex justify-content-between">
                {!anyLocationsDefined && (
                    <FormGroup className="w-14">
                        <FormLabel text="Road Name" required={true} />
                        <Input
                            id="longTermSchedule.roadName"
                            name="longTermSchedule.roadName"
                            value={longTermSchedule.roadName}
                            onChange={onChange}
                            type="text"
                            required={true}
                            disabled={longTermSchedule.isPublished}
                            maxLength={100}
                            valid={Boolean(
                                longTermSchedule.roadName &&
                                longTermSchedule.roadName.trim().length > 0
                            )}
                        />
                        <ValidationErrorMessage>
                            Road Name is required.
                        </ValidationErrorMessage>
                    </FormGroup>
                )}

                {anyLocationsDefined && (
                    <FormGroup className="w-25">
                        <FormLabel text="Location" required />
                        <Select
                            id="longTermSchedule.arcGisLocationId"
                            name="longTermSchedule.arcGisLocationId"
                            options={arcGisLocations}
                            getOptionValue={(agl) => agl.id}
                            getOptionLabel={(agl) =>
                                agl.isActive
                                    ? agl.addrLoc
                                    : `[INACTIVE] ${agl.addrLoc}`
                            }
                            value={
                                arcGisLocations.filter(
                                    (agl) =>
                                        agl.id ==
                                        longTermSchedule.arcGisLocationId
                                ) ?? ''
                            }
                            onChange={onArcGisLocationChange}
                            menuPlacement="top"
                        />
                    </FormGroup>
                )}

                <FormGroup className="w-14">
                    <FormLabel text={applicationGroup.groupName} />
                    <Input
                        id="longTermSchedule.scheduleApplicationGroupCount.count"
                        name="longTermSchedule.scheduleApplicationGroupCount.count"
                        value={
                            longTermSchedule.scheduleApplicationGroupCount.count
                        }
                        onChange={onChange}
                        type="number"
                        disabled={isReleased || isCancelled}
                        valid={Boolean(
                            !longTermSchedule.scheduleApplicationGroupCount
                                .count ||
                            (longTermSchedule.scheduleApplicationGroupCount
                                .count > 0 &&
                                longTermSchedule.scheduleApplicationGroupCount
                                    .count < MaxResourceCount)
                        )}
                        max={MaxResourceCount}
                    />
                    <ValidationErrorMessage>
                        Count should be greater than zero and less than or equal
                        to {MaxResourceCount}.
                    </ValidationErrorMessage>
                </FormGroup>

                {longTermSchedule.scheduleEquipmentGroupCounts.map(
                    (segc, i) => {
                        const equipmentGroup = equipmentGroups.find(
                            (eg) => eg.id == segc.equipmentGroupId
                        );

                        const indexLookup = `longTermSchedule.scheduleEquipmentGroupCounts[${i}].count`;
                        const equipmentLabel = equipmentGroup.isTruck
                            ? `Brokered ${equipmentGroup.name}`
                            : equipmentGroup.name;

                        return (
                            <FormGroup
                                key={segc.equipmentGroupId}
                                className="w-14"
                            >
                                <FormLabel text={equipmentLabel} />

                                <Input
                                    id={indexLookup}
                                    name={indexLookup}
                                    value={segc.count}
                                    onChange={onEquipmentGroupChange}
                                    type="number"
                                    disabled={isReleased || isCancelled}
                                    invalid={Boolean(
                                        segc.count === '' ||
                                        segc.count < 0 ||
                                        segc.count > MaxResourceCount
                                    )}
                                    max={MaxResourceCount}
                                    min={0}
                                />
                                <ValidationErrorMessage>
                                    Count should be greater than zero and less
                                    than or equal to {MaxResourceCount}.
                                </ValidationErrorMessage>
                            </FormGroup>
                        );
                    }
                )}
            </div>
        );
    }
}
